import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);

    const init = () => {
        dom.on('click', e => {
            dom.parent().removeClass('-collapsed');
            dom.remove();
        });
    };

    const destroy = () => {
        dom.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ExpandTextButton.js